<template>
  <div>
    <sticky v-if="lead" class="page-header sticky-page-header page-header--new" :back-button="true">
      <div slot="left">
        <h1 class="title is-3">
          <span class="is-uppercase">Fiche Lead</span>
          <!-- <router-link :to="{name: 'LeadList'}" class="has-text-weight-black is-underline is-dotted">Leads</router-link> -->
        </h1>
      </div>
      <a class="dropdown-item has-text-danger" slot="dropdown-content" @click="deleteLead()" v-if="isAdmin || isOperator">
        <span class="icon"><i class="fal fa-trash"></i></span>
        <span>Supprimer</span>
      </a>
    </sticky>
    <spinner :isLoading="loading" v-if="loading"></spinner>
    <div v-else-if="lead" class="columns is-padding-left-on-btn-actions is-padding-right-on-btn-actions has-stickyColumn has-stickyColumn--left">
      <div class="column is-4 is-3-fullhd is-paddingless-left is-paddingless-right">
        <div class="card has-bg-white is-bordered">
          <div v-if="lead.exported" class="columns is-border-bottom is-border-dashed">
            <div class="column is-4">
              <span class="tag is-success is-small">Exporté en contact</span>
            </div>
            <div v-if="lead.exported_on" class="column is-margin-left">
              <span class="">Le {{lead.exported_on | prettyDatetime}}</span>
            </div>
          </div>
          <div class="is-padding">
            <div class="has-text-primary is-size-4 is-margin-bottom">
              Informations
            </div>
            <div class="has-text-primary is-size-6">
              <b>Origine :</b> {{lead.origin_name}}
            </div>
            <div class="has-text-primary is-size-6">
              <b>Premier contact :</b> le {{lead.created_on|date}} à  {{lead.created_on|prettyTime}}
            </div>
            <!-- <div class="has-text-primary is-size-6">
              <b>Dernière intéraction :</b> Le XX/XX/XX par X.
            </div> -->

            <div class="field is-grouped is-margin-top-small">
              <p v-if="!lead.exported" class="control">
                <button class="button is-primary is-radius-large is-size-7" @click="openNewCommentQuickview">
                  <span class="icon is-small is-margin-right-small"><i class="fas fa-pen-alt"></i></span>
                  <span>Ajouter une note</span>
                </button>
              </p>
              <p class="control">
                <button class="button is-info is-radius-large is-size-7 is-min-width-0"
                        @click="openNotesQuickview"
                        :disabled="!lead.comments || !lead.comments.length">
                  <span class="icon is-small is-margin-right-small"><i class="fas fa-comment-alt"></i></span>
                  <span v-if="lead.comments && lead.comments.length">{{lead.comments.length}}</span>
                  <span v-else>0</span>
                </button>
              </p>
            </div>
          </div>
          <div class="has-text-primary is-size-6 is-padding-top-small is-padding-bottom-small is-padding-left is-padding-right">
            <div class="columns is-vcentered is-gapless">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Nom</b></div>
              <div class="column">{{lead.last_name}}</div>
            </div>
            <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Prénom</b></div>
              <div class="column">{{lead.first_name}}</div>
            </div>
            <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Email</b></div>
              <div class="column is-break-word">{{lead.email}}</div>
            </div>
            <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Téléphone</b></div>
              <div class="column">{{lead.phone}}</div>
            </div>
            <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Ville</b></div>
              <div class="column">
                <span v-if="lead.address && lead.address.city">{{lead.address.city}}</span>
                <span v-else>NC</span>
              </div>
            </div>
            <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Code postal</b></div>
              <div class="column">
                <span v-if="lead.address && lead.address.zip_code">{{lead.address.zip_code}}</span>
                <span v-else>NC</span>
              </div>
            </div>
            <div class="columns is-vcentered is-gapless is-margin-top-xxsmall">
              <div class="column is-narrow w90p is-margin-right-small is-uppercase"><b>Programme</b></div>
              <div class="column">
                <router-link v-if="lead.program && lead.program_name" :to="{name: 'ProgramVue', params: {id: lead.program}}">
                  <span>{{lead.program_name}}</span>
                </router-link>
                <span v-else-if="lead.program_name">{{lead.program_name}}</span>
                <span v-else>NC</span>
              </div>
            </div>
          </div>
          <div class="is-padding">
            <div class="has-text-primary is-size-6 is-uppercase">
              <b>Informations complémentaires</b>
            </div>
          </div>
          <div class="is-padding has-bg-light is-border-top">
            <div class="columns is-gapless is-multiline">
              <div class="label"
                :class="{'column is-5 is-margin-right-small': !lead.comment || !lead.comment.length, 'column is-12': lead.comment && lead.comment.length}"
              >Commentaire contact :</div>
              <div class="has-text-primary is-size-6 is-italic"
                  v-if="lead.comment && lead.comment.length">
                <span v-html="lead.comment"></span>
              </div>
              <div class="has-text-primary is-size-6 is-italic column" v-else>NC</div>
            </div>

            <div class="has-text-primary is-size-6 is-margin-top">
              <div v-for="field in lead.additional_fields" class="columns is-gapless is-margin-top-xxsmall">
                <div class="column is-5 is-margin-right-small">
                  <span class="label ">{{field.name}}</span>
                </div>
                <div class="column">
                  <span>{{field.value}}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="lead.contact">
            <router-link :to="{name: 'ContactVue', params: {id: lead.contact}}" class="is-fullwidth button is-success">
              Fiche Contact
            </router-link>
          </div>
        </div>
      </div>
      <div class="column is-8 is-9-fullhd is-paddingless-right is-paddingless-bottom" v-if="!lead.exported">
        <div class="is-border">
          <contact-form @submit="submit" @saveLead="saveEditLead" :source="contact" :loading="loading"
                        :fromLead="true"></contact-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ContactForm from '@/components/contact/ContactForm'
  import { mapGetters, mapState } from 'vuex'

  const emptyContact = {
    nature: null,
    seller: null,
    first_name: null,
    last_name: null,
    email: null,
    mobile: null,
    phone: null,
    address: {
      city: null,
      zip_code: null,
      line1: null
    },
    comment: null
  }

  let cleanPhoneNumber = function (value) {
    value = value.replace('+', '')
    value = value.replace(/ +/g, '')
    if (value.slice(0, 2) === '33') {
      value = value.slice(2)
      value = '0'.concat(value)
    } else if (value.slice(0, 1) === '3') {
      value = value.slice(1)
    }
    return value
  }

  export default {
    name: 'Lead',
    data () {
      return {
        panel: 'lead',
        loading: false,
        lead: null,
        contact: null,
        users: null,
        clonedLead: null
      }
    },
    components: {ContactForm},
    computed: {
      ...mapState(['quickview']),
      ...mapGetters(['isAdmin', 'isOperator']),
      canSubmit () {
        return this.errors.any() === false && (this.contact.phone || this.contact.mobile)
      },
      leadPk () {
        return this.$route.params.id
      }
    },
    watch: {
      '$route' (to, from) {
        if (to.params.id !== from.params.id) {
          this.loadLead()
        }
      },
      'panel' (val, oldVal) {
        if (val !== oldVal) {
          this.$validator.reset()
        }
      },
      quickview ({mode, params, results}) {
        if (results) {
          if (mode === 'NEW_NOTE') {
            this.addNote(results)
          }
        }
      }
    },
    methods: {
      async submit (lead) {
        if (lead.seller && lead.seller.pk) {
          lead.seller = lead.seller.pk
        }
        await this.saveEditLead(lead)
        this.$validator.validateAll()
          .then(isValid => {
            if (isValid) {
              this.createContact()
            } else {
              this.$notify({
                type: 'is-danger',
                text: 'Oups ! Merci de compléter les champs obligatoires.'
              })
            }
          })
          .catch(err => {
            console.log('form validation error > ', err)
          })
      },
      exportLead (callback) {
        let payload = {
          exported: true
        }
        this.$api.leadService.patch(this.leadPk, payload).then(r => {
          if (callback) {
            callback()
          }
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Impossible de marquer le lead en modifié'
          })
        })
      },
      createContact () {
        let data = Object.assign({}, this.contact)
        data.lead = this.leadPk
        this.$api.contactService.post(data).then(res => {
          this.loading = false
          this.$notify({
            type: 'is-success',
            text: 'Contact enregistré.'
          })
          let callback = () => {
            this.$router.push({name: 'ContactVue', params: {id: res.data.pk}})
          }
          this.exportLead(callback)
        }).catch(() => {
          this.loading = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout du contact.'
          })
        })
      },
      loadLead () {
        this.loading = true
        this.$api.leadService.getOne(this.leadPk).then(r => {
          let lead = r.data
          this.loading = false
          if (lead.phone && lead.phone.length > 0) {
            lead.phone = cleanPhoneNumber(lead.phone)
          }
          this.lead = Object.assign({}, lead)
          this.initContactForm()
        }).catch(r => {
          this.loading = false
          this.$router.replace({name: 'NotFound'})
        })
      },
      deleteLead () {
        this.$swal({
          title: 'Suppression',
          text: 'Êtes vous sûr de vouloir supprimer ce lead ?',
          confirmButtonText: 'Supprimer'
        }).then(r => {
          if (r.value) {
            this.$api.leadService.delete(this.leadPk)
              .then(res => {
                this.$router.push({name: 'LeadList'})
              })
          }
        })
      },
      initContactForm () {
        this.$set(this, 'contact', Object.assign({}, emptyContact, this.lead))
      },
      addNote (comment) {
        this.$api.leadService.postComment(this.lead.pk, {comment}).then(r => {
          this.lead.comments.push(r.data)
        })
      },
      openNewCommentQuickview () {
        this.$store.commit('setQuickview', {mode: 'NEW_NOTE'})
      },
      editNote (note) {
        this.$api.leadService.patchComment(this.lead.pk, note).then(() => {
          this.$notify({text: 'Commentaire sauvegardé', type: 'is-success'})
        })
      },
      openNotesQuickview () {
        this.$store.commit('setQuickview', {mode: 'NOTES', params: {source: this.lead.comments, leadToggle: !this.lead.exported, editNote: this.editNote}})
      },
      async saveEditLead (lead) {
        try {
          let { data } = await this.$api.leadService.patch(this.leadPk, lead)
          this.lead = data
          this.initContactForm()
          this.$notify({
            type: 'is-success',
            text: 'Le lead a bien été mis à jour'
          })
        } catch (e) {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du lead.'
          })
        }
      }
    },
    created () {
      this.loadLead()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lead/Lead.vue